<script setup>

import {defineProps, ref, defineEmits} from "vue";

const props = defineProps({
  resourceId: {
    type: String,
    required: true,
  },
  resourceName: {
    type: String,
    required: true,
  },
  resourceType: {
    type: String,
    required: true,
  },
  resourceList: {
    type: Array,
    required: true
  },
  resourceTypes: {
    type: Array,
    required: true,
  },
});
const name = ref(props.resourceName);
const emit = defineEmits(['search', 'updateType']);
const search = () => {
  emit('search', name)
};

const updateType = (resourceTypeId) => {
  emit('updateType', resourceTypeId)
};
</script>

<template>
  <van-space direction="vertical" fill>
    <van-search v-model="name" @search="search" @cancel="search" :placeholder="'Search for your ' + resourceId"/>
    <van-grid clickable :column-num="3">
      <van-grid-item :icon="rtype.icon" v-for="rtype in resourceTypes" :key="rtype.id" :dot="resourceType === rtype.id"
                     @click="updateType(rtype.id)"/>
    </van-grid>
    <div v-if="resourceList.length === 0">
      <van-empty image="search" description="Nothing found"/>
    </div>
    <div v-if="resourceList.length > 0">
      <van-card
          :tag="resource.type"
          v-for="resource in resourceList"
          :key="resource.id"
          :title="resource.name"
          :desc="resource.short_description"
          :thumb="resource.icon_url"
      >
        <template #tags>
          <van-tag v-if="resource.treatment_session_id != null" plain round type="primary">
            {{
              resource.treatment_session
            }}
          </van-tag>
        </template>
        <template #footer>
          <span v-if="resource.treatment_session_id != null">
            <van-button icon="todo-list-o" size="small"
                        :to="'/session/' + resource.treatment_session_id"></van-button>
          </span>
          <van-button icon="play-circle-o" size="small" :to="'/' + resourceId + '/' + resource.id"></van-button>
        </template>
      </van-card>
    </div>
  </van-space>
</template>
